export const formatFilterValue = (value: string, columnName: string) => {
  let query = [];
  let sym = "";
  if (
    value.match("<=") !== null ||
    value.match(">=") !== null ||
    value.match("!=") !== null ||
    value.match("=") !== null
  ) {
    sym = "=";
  } else if (value.match(">") !== null) {
    sym = ">";
  } else if (value.match("<") !== null) {
    sym = "<";
  } else if (value.match("!") !== null) {
    sym = "!";
  }
  let res = sym === "" ? value : (value ?? "")?.split(sym);

  if ((value.includes("&") || value.includes(",")) && sym === "") {
    let updatedValue = (value ?? "")
      ?.split("&")
      .map((i) => i.trim())
      .join(",");
    query.push({
      in: [
        {
          columnName: columnName,
          value: updatedValue?.split(",").map((x) => x.trim()),
        },
      ],
    });
  } else if (sym === "=" && res?.length === 2 && res[0] === "!") {
    const resultValue = res[1]?.trim()?.split(",");
    query.push(
      resultValue?.length === 1
        ? {
            neq: [{ columnName: columnName, value: resultValue[0] }],
          }
        : {
            notIn: [{ columnName: columnName, value: resultValue }],
          },
    );
  } else if (sym === "=" && res?.length === 2 && res[0] === "") {
    const resultValue = res[1]?.trim()?.split(",");
    query.push(
      resultValue.length === 1
        ? {
            eq: [{ columnName: columnName, value: resultValue[0] }],
          }
        : {
            in: [{ columnName: columnName, value: resultValue }],
          },
    );
  } else if (sym === "=" && res?.length === 2 && res[0] === ">") {
    query.push({
      gte: [{ columnName: columnName, value: res[1].trim() }],
    });
  } else if (sym === "=" && res?.length === 2 && res[0] === "<") {
    query.push({
      lte: [{ columnName: columnName, value: res[1].trim() }],
    });
  } else if (sym === "<" && res?.length === 2 && res[0] === "") {
    query.push({
      lt: [{ columnName: columnName, value: res[1].trim() }],
    });
  } else if (sym === ">" && res?.length === 2 && res[0] === "") {
    query.push({
      gt: [{ columnName: columnName, value: res[1]?.trim() }],
    });
  } else if (sym === "!" && res?.length === 2 && res[0] === "") {
    query.push({
      notIn: [{ columnName: columnName, value: res[1]?.trim()?.split(",") }],
    });
  } else {
    query.push({
      like: [{ columnName: columnName, value: value?.trim() }],
    });
  }
  return query[0];
};
